import { axiosInstance } from './axiosInstance';

// Get all custom field groups for a type
export const getCustomFieldGroups = type => {
    return axiosInstance
        .get(`customFieldGroups/${type}`)
        .then(response => response.data)
        .catch(error => {
            throw error.response;
        });
};

// Create new custom field group
export const createCustomFieldGroup = (type, data) =>
    axiosInstance
        .post(`customFieldGroups/${type}`, data)
        .then(response => response.data)
        .catch(error => {
            throw error.response;
        });

// Update existing custom field group
export const updateCustomFieldGroup = (type, cfgId, data) =>
    axiosInstance
        .put(`customFieldGroups/${type}/${cfgId}`, data)
        .then(response => response.data)
        .catch(error => {
            throw error.response;
        });

// Delete custom field group
export const deleteCustomFieldGroup = (type, cfgId) =>
    axiosInstance
        .delete(`customFieldGroups/${type}/${cfgId}`)
        .then(response => response.data)
        .catch(error => {
            throw error.response;
        });

// Add entity to custom field group
export const addEntity = (type, cfgId, entityId) =>
    axiosInstance
        .put(`customFieldGroups/${type}/${cfgId}/entity/${entityId}`)
        .then(response => response.data)
        .catch(error => {
            throw error.response;
        });

export const updateEntities = (type, cfgId, entities) =>
    axiosInstance
        .put(`customFieldGroups/${type}/${cfgId}/entity`, { entities })
        .then(response => response.data)
        .catch(error => {
            throw error.response;
        });

export const updateItems = (type, cfgId, items) =>
    axiosInstance
        .put(`customFieldGroups/${type}/${cfgId}/item`, { items })
        .then(response => response.data)
        .catch(error => {
            throw error.response;
        });

// Remove entity from custom field group
export const removeEntity = (type, cfgId, entityId) =>
    axiosInstance
        .delete(`customFieldGroups/${type}/${cfgId}/entity/${entityId}`)
        .then(response => response.data)
        .catch(error => {
            throw error.response;
        });

// Add item to custom field group
export const addItem = (type, cfgId, itemId) =>
    axiosInstance
        .put(`customFieldGroups/${type}/${cfgId}/item/${itemId}`)
        .then(response => response.data)
        .catch(error => {
            throw error.response;
        });

// Remove item from custom field group
export const removeItem = (type, cfgId, itemId) =>
    axiosInstance
        .delete(`customFieldGroups/${type}/${cfgId}/item/${itemId}`)
        .then(response => response.data)
        .catch(error => {
            throw error.response;
        });

export const copySelections = (type, cfgId, cfGroupIds) =>
    axiosInstance
        .patch(`customFieldGroups/${type}/${cfgId}/copy`, { cfGroupIds })
        .then(response => response.data)
        .catch(error => {
            throw error.response;
        });

export const copyCustomFields = (type, targetCfgIds, customFields) =>
    axiosInstance
        .patch(`customFieldGroups/${type}`, { targetCfgIds, customFields })
        .then(response => response.data)
        .catch(error => {
            throw error.response;
        });

export const moveCustomFields = (type, cfgId, targetCfgId, customFields) =>
    axiosInstance
        .put(`customFieldGroups/${type}`, { cfgId, targetCfgId, customFields })
        .then(response => response.data)
        .catch(error => {
            throw error.response;
        });
